import React from 'react';
import { Row, Col, Button } from "react-bootstrap";


/**
 * RealtimeRowToggle - Display a toggle button for non-timepoint stops
 */
export default function RealtimeRowToggle({ onToggle, isOpen, children }) {
  const ref = React.useRef(null);

  const handleClick = () => {
    onToggle(!isOpen);
  };

  return (
    <Row className={`stop__row stop__row--toggle ${isOpen ? 'open' : ''}`}>
      <Col>
        <Button
          ref={ref}
          onClick={handleClick}
          aria-label={isOpen ? 'Hide non-timepoint stops' : 'Show non-timepoint stops'}
        >
          <i className={`fas ${isOpen ? 'fa-minus-circle' : 'fa-plus-circle'}`} aria-hidden="true"></i>
          {' '}{isOpen ? 'Hide' : 'Show'} Non-Timepoint Stops
        </Button>
      </Col>
    </Row>
  );
}
